
import './App.css';
// import Navbar from './Components/Navbar';
import NoteBook from './Components/NoteBook';
// import Todo from './Components/Todo';

function App() {
  return (
    <>
      {/* <Navbar /> */}
      {/* <Todo /> */}
      <NoteBook/>
    </>
  );
}

export default App;
